import { render, staticRenderFns } from "./EmbedSlider.vue?vue&type=template&id=3a989f20&scoped=true&"
import script from "./EmbedSlider.vue?vue&type=script&lang=js&"
export * from "./EmbedSlider.vue?vue&type=script&lang=js&"
import style0 from "./EmbedSlider.vue?vue&type=style&index=0&id=3a989f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a989f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VCol,VRow,VSheet})
